import * as React from "react";
const SvgFiRrArrowRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M23.12 9.91 19.25 6a1 1 0 1 0-1.42 1.41L21.39 11H1a1 1 0 0 0 0 2h20.45l-3.62 3.61a1.002 1.002 0 0 0 .325 1.639 1 1 0 0 0 1.095-.22l3.87-3.88a3 3 0 0 0 0-4.24"
    />
  </svg>
);
export default SvgFiRrArrowRight;
